import { LoremIpsum } from 'lorem-ipsum';

export default /* @ngInject */ (
	/** @type {any} */ $scope,
	/** @type {import('angular').ITimeoutService} */ $timeout,
	/** @type {import('angular').translate.ITranslateService} */ $translate,
	/** @type {any} */ KTranslate,
) => {
	if ($scope.builder) {
		const demoRepre = () => {
			const nbSamples = 2;

			$timeout(() => {
				const lorem = new LoremIpsum({ wordsPerSentence: { min: 1, max: 3 } });

				if (!Array.isArray($scope.data[$scope.component.key])) {
					$scope.data[$scope.component.key] = [];
				}
				$scope.data[$scope.component.key].length = 0;

				for (let n = 0; n < nbSamples; n++) {
					const repre = $scope.component.langs.map((/** @type {string} */ lang) => ({
						lang,
						type:  'K_NODE;STRING',
						value: lorem.generateWords(1),
					}));
					$scope.data[$scope.component.key].push({
						kid: `K_NODE;${lorem.generateWords(1).toUpperCase()}`,
						repre,
					});
				}
			});
		};

		$timeout(() => {
			if ($scope.component.langs.length === 0) {
				$scope.component.langs.push({
					kid:         'K_NODE;UNIVERSEL',
					name:        $translate.instant('common.name'),
					displayLang: false,
				});
			}
		});

		$scope.$watch('component.langs', demoRepre, true);

		// Automatically sets label and langs according to the path
		$scope.$watch('component.kdata.path', async (/** @type {any[]}} */ path) => {
			if (Array.isArray(path) && path.length > 0) {
				const lastPathItem = path.at(-1);
				$scope.$parent.langKid = lastPathItem.kid;
				if (!lastPathItem.name) {
					lastPathItem.name = await KTranslate.request($scope, lastPathItem.kid);
				}
				$timeout(() => {
					$scope.component.label = lastPathItem.name;
				});
			}
		}, true);
	}
};
